import { useGetN8NFlowSchema } from "@/queries/n8n";
import { cn } from "@/utils/theme";
import { useWorkflowStore } from "@/workflow_api/store/workflowStore";
import type { NodeData } from "@/workflow_api/types/workflow";
import { Icon } from "@elaniintc/goes-design-system";
import { VariableKeyBox } from "../key-box";

const Content = ({ node }: { node: NodeData; flowId: string }) => {
  const n8nFlow = node.inputs.find((input) => input.name === "workflow")
    ?.value as string;

  const {
    data: n8nFlowSchema,
    isPending,
    isError,
    error,
  } = useGetN8NFlowSchema(n8nFlow);

  if (isError) {
    return (
      <div className="text-sm text-danger">
        {error?.message || "An unexpected error occurred."}
      </div>
    );
  }

  if (isPending) {
    return (
      <Icon
        name="spinner-third"
        className="animate-spin text-sm text-on-disabled"
        type="far"
      />
    );
  }

  if (!n8nFlowSchema.outputs) {
    return null;
  }

  return (
    <div className="flex">
      <div
        className={cn("w-0.5 relative translate-x-[25px]", "bg-transparent")}
      >
        <span className="absolute left-3 top-[14px] w-2 h-2 bg-neutral-object-accent rounded-full"></span>
        <span className="absolute w-3 h-5 border-l-2 border-t-2 border-neutral-object-accent rotate-x-180 rounded-tl-md"></span>
      </div>

      <div className="relative pl-[50px] mb-4 w-full">
        <div className="py-1">
          <div className="space-y-3">
            {n8nFlowSchema?.outputs?.map((variable, index) => {
              return Object.keys(variable).map((key) => {
                const v = variable[key];
                return (
                  <VariableKeyBox
                    key={`variable-${key}-${index}`}
                    name={key}
                    type={v.type}
                  />
                );
              });
            })}
          </div>
        </div>
      </div>
    </div>
  );
  return <></>;
};

export const N8NVariables = ({ id }: { id: string }) => {
  const { getNodeById, flowId } = useWorkflowStore();
  const node = getNodeById(id);

  if (!node) return <></>;

  return <Content node={node.data as unknown as NodeData} flowId={flowId} />;
};
